/** @format */

import {
	ComponentRef,
	Directive,
	Input,
	OnChanges,
	SimpleChanges,
	TemplateRef,
	ViewContainerRef
} from '@angular/core';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { SkeletonShape } from '../../models/skeleton-loader.interface';

@Directive({
	selector: '[skeletonLoader]'
})
export class SkeletonLoaderDirective implements OnChanges {
	@Input() skeletonLoader = false;
	@Input() skeletonLoaderRepeat = 1;
	@Input() skeletonLoaderType: SkeletonShape = SkeletonShape.DEFAULT;

	constructor(
		private templateRef: TemplateRef<unknown>,
		private viewContainerRef: ViewContainerRef
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.skeletonLoader) {
			this.viewContainerRef.clear();
			this.renderView(
				changes.skeletonLoader.currentValue,
				this.skeletonLoaderType,
				this.skeletonLoaderRepeat
			);
		}
	}

	private renderView(
		isLoading: boolean,
		skeletonShape: SkeletonShape,
		skeletonCount: number
	): void {
		if (!isLoading) {
			this.viewContainerRef.createEmbeddedView(this.templateRef);
			return;
		}

		const componentRef: ComponentRef<SkeletonComponent> =
			this.viewContainerRef.createComponent(SkeletonComponent);
		componentRef.setInput('skeletonShape', skeletonShape);
		componentRef.setInput('skeletonCount', skeletonCount);
	}
}
